export default __webpack_public_path__ + "static/media/Resume.f44591f8.pdf";